{
  "connections": {
    "branch": "Branch",
    "corpus": "Korpus: {{name}}",
    "details": "Details",
    "empty": "Dieses Projekt hat keine Quellverbindungen.",
    "host": "Läuft auf dem PC von",
    "loading": "Quellverbindungen werden geladen…",
    "none": "noch keiner",
    "policies": {"automatic": "Automatisch", "on_demand": "Auf Anfrage"},
    "policy": "Aktualisierung",
    "sample_one": "Stichprobe mit {{count}} Eintrag",
    "sample_other": "Stichprobe mit {{count}} Einträgen",
    "states": {
      "failed": "Aktualisierung fehlgeschlagen",
      "pending": "Aktualisierung vorgemerkt",
      "proposed": "Aktualisierung wartet auf Review",
      "running": "Aktualisierungs-Durchlauf läuft",
      "up_to_date": "Auf dem neuesten Stand",
      "update_available": "Aktualisierung verfügbar",
      "waiting_for_approval": "Aktualisierung wartet auf die Freigabe eines Werkzeugs auf dem PC, auf dem sie läuft",
      "waiting_for_host": "Warten, bis der DMW Connector des PCs, auf dem sie läuft, online ist",
      "waiting_for_you": "Aktualisierung wartet auf Sie"
    },
    "title": "Quellverbindungen",
    "updateNow": "Jetzt aktualisieren",
    "uploaded": "In DMW hochgeladen",
    "versions": "Quelle bei {{upstream}}, importiert {{imported}}"
  },
  "corpus": {
    "allHidden": "Alle Korpora sind ausgeblendet. Haken Sie eines an, um seine Dokumente aufzulisten.",
    "details": "Details zu {{corpus}}",
    "latest": "Neueste Version",
    "latestLabelled": "Neueste Version {{version}}",
    "shortKeys": "Kurzform",
    "shown": "Korpora in der Liste"
  },
  "document": {
    "added": {
      "annotations": "Annotationen",
      "edit": "Bearbeiten",
      "hideOthers": "Vorschläge und abgeschlossene Ergebnisse ausblenden",
      "loading": "Hinzugefügtes wird geladen …",
      "openItem": "Öffnen",
      "openItemHint": "Seite des Annotationssatzes",
      "openResult": "Öffnen",
      "openResultHint": "Das Ergebnis, aus dem diese Aussagen stammen",
      "openResultNumbered": "Öffnen {{number}}",
      "openReview": "Review öffnen",
      "openThread": "Durchlauf öffnen",
      "otherVersion": "Auf",
      "proposeEdits": "Änderungen vorschlagen",
      "showInText": "Im Text zeigen",
      "showOthers_one": "{{count}} Vorschlag oder abgeschlossenes Ergebnis zeigen",
      "showOthers_other": "{{count}} Vorschläge und abgeschlossene Ergebnisse zeigen",
      "statementCount_one": "{{count}} Aussage",
      "statementCount_other": "{{count}} Aussagen",
      "statements": "Aussagen",
      "stopEditing": "Editor schließen"
    },
    "findingLatest": "Neueste Version wird gesucht…",
    "loading": "Dokument wird geladen …",
    "metadata": "Metadaten",
    "noFullText": "Dieses Dokument hat keinen Volltext.",
    "olderVersion": "Ältere Version",
    "regest": {
      "proposed": "Vorgeschlagen",
      "unnamed": "Nicht benannt",
      "unplaced": "Nicht in diesem Text"
    },
    "startThread": "Durchlauf mit diesem Dokument starten",
    "startThreadOnSegment": "Durchlauf mit diesem Segment starten",
    "title": "{{documentKey}}",
    "unnamed": "Dokument"
  },
  "import": {
    "advanced": "Erweitert",
    "asDocuments": "Die Dateien werden hochgeladen, und ein Durchlauf des Import-Prozessschemas wandelt sie um. Das Ergebnis geht zum Review an Kuratierende.",
    "asJsonLines": "Eine JSON-Lines-Datei wird direkt importiert, als neue Korpusversion.",
    "blockers": {
      "chooseFiles": "Wählen Sie zuerst eine Datei oder einen Ordner.",
      "connectRepository": "Verbinden Sie sich zuerst mit dem Dienst des Repositorys.",
      "consentPrivate": "Bestätigen Sie zuerst, dass Sie das private Repository teilen dürfen.",
      "enterRemote": "Geben Sie zuerst die Adresse des Repositorys an.",
      "installApp": "Installieren Sie zuerst DMWs App im Repository.",
      "nameCorpus": "Geben Sie dem Korpus zuerst einen Namen.",
      "noContentYet": "Dieses Projekt hat noch keine Inhalte und daher kein Import-Prozessschema. DMW gibt jedem Projekt die DMW-Bibliothek mit „Textdokumente einlesen“; der Server fügt sie beim nächsten Start hinzu.",
      "noImportWorkflow": "Wählen Sie eine JSON-Lines-Datei oder bitten Sie die Projektadministration, ein Import-Prozessschema einzurichten.",
      "workflowsFailed": "Die Import-Prozessschemata ließen sich nicht lesen; siehe die Meldung oben.",
      "workflowsLoading": "Das Import-Prozessschema wird gesucht …"
    },
    "button": "Importieren",
    "cloud": {
      "branch": "Branch",
      "interval": "Nach neuen Commits sehen",
      "intervals": {
        "asked": "Nur auf Anfrage",
        "daily": "Täglich",
        "hourly": "Stündlich",
        "weekly": "Wöchentlich"
      },
      "policies": {"automatic": "Automatisch", "on_demand": "Auf Anfrage"},
      "policy": "Aktualisierung",
      "policyHints": {
        "automatic": "Jeder neue Commit wird in einem Durchlauf importiert.",
        "on_demand": "Neue Commits warten, bis jemand sie anfordert."
      },
      "private": {
        "checkAgain": "Erneut prüfen",
        "checking": "Das Repository wird geprüft …",
        "connect": "{{repository}} ist privat oder existiert nicht. Verbinden Sie sich mit {{provider}}, damit DMW es lesen kann, und importieren Sie dann erneut.",
        "connectAction": "Mit {{provider}} verbinden",
        "consent": "Alle in diesem Projekt dürfen lesen, was DMW daraus kopiert, samt Verlauf. Ich darf es mit ihnen teilen.",
        "installAction": "DMWs App installieren",
        "not_configured": "Falls {{repository}} privat ist: {{provider}}-Verbindung nicht eingerichtet. Ein öffentliches Repository wird wie gewohnt importiert.",
        "not_visible": "Ihre {{provider}}-Verbindung sieht {{repository}} nicht. Installieren Sie DMWs App darin oder prüfen Sie die Adresse.",
        "ready": "{{repository}} ist privat. DMW liest es über Ihre {{provider}}-Verbindung.",
        "reconnect": "Ihre {{provider}}-Verbindung muss neu hergestellt werden, bevor DMW {{repository}} lesen kann.",
        "reconnectAction": "Erneut mit {{provider}} verbinden"
      },
      "remote": "Adresse des Repositorys",
      "remoteHint": "Eine https://-Adresse; DMW liest nur daraus. Ein privates GitHub-Repository wird über Ihre eigene GitHub-Verbindung gelesen.",
      "submit": "Verbinden und Import ausführen",
      "working": "Verbinden und abrufen … Ein großes Repository kann einige Minuten dauern."
    },
    "corpus": "Korpus",
    "corpusName": "Name des Korpus",
    "files": "Datei oder Ordner",
    "filesHint": "Eine JSON-Lines-Datei oder Textdokumente: TXT, Markdown, HTML, DOCX, PDF.",
    "importing": "Wird importiert…",
    "intro": "Von diesem PC oder aus einem Git-Repository, dem DMW folgt.",
    "kind": "Woher",
    "kindHints": {
      "cloud": "Ein Git-Repository, dem DMW folgt",
      "local": "Eine Datei oder ein Ordner von diesem PC"
    },
    "kinds": {"cloud": "Cloud", "local": "Lokal"},
    "mode": "Importmodus",
    "modes": {
      "replace_all": "Alles ersetzen: Dokumente, die in der Datei fehlen, werden entfernt",
      "upsert": "Hinzufügen und aktualisieren: andere Dokumente bleiben"
    },
    "newCorpus": "Neues Korpus…",
    "newCorpusName": "Name des neuen Korpus",
    "openTool": "Werkzeug öffnen",
    "openToolHint": "Sehen Sie nach, wie es arbeitet; „Den Agenten fragen“ auf seiner Seite macht eine neue Version.",
    "openWorkflow": "Prozessschema öffnen",
    "otherProject": "Dieser Import wurde in einem anderen Projekt vorbereitet. Wählen Sie dieses Projekt oben, um fortzufahren, oder starten Sie den Import hier neu.",
    "replaceSegmentation": "Segmentierung dieses Korpus ersetzen (segmentiert jedes Dokument neu)",
    "result": {
      "connected": "„{{source}}“ aktualisiert jetzt „{{corpus}}“.",
      "connectedTitle": "Verbunden",
      "counts": "Hinzugefügt {{added}}, geändert {{modified}}, entfernt {{removed}}, unverändert {{unchanged}}.",
      "documentsVersion": "Das Korpus ist jetzt bei Version {{version}}.",
      "firstFetch": {
        "failed": "Der erste Abruf ist fehlgeschlagen; die Verbindung ist gespeichert. Prüfen Sie Adresse und Branch. Ein privates Repository lässt sich noch nicht abrufen: DMW liest nur, was jeder ohne Anmeldung lesen kann.",
        "fetched": "Der erste Abruf ist da.",
        "unchanged": "Der erste Abruf fand auf diesem Branch noch keine Commits."
      },
      "open": "Dokumente öffnen",
      "segmentationChanged": "Diese Version wendet die neue Segmentierung auf jedes Dokument an.",
      "title": "Import abgeschlossen",
      "unchanged": "Nichts geändert; das Korpus bleibt bei Version {{version}}.",
      "uploadTitle": "Hochgeladen",
      "uploadUnchanged": "„{{source}}“ enthält diese Dateien schon; es gibt nichts Neues zu importieren.",
      "uploaded_one": "{{count}} Datei ist jetzt Commit {{commit}} von „{{source}}“, für „{{corpus}}“.",
      "uploaded_other": "{{count}} Dateien sind jetzt Commit {{commit}} von „{{source}}“, für „{{corpus}}“."
    },
    "run": {
      "failed": "Der Import-Durchlauf konnte nicht starten; die Quellverbindungen sagen, warum.",
      "open": "Durchlauf öffnen",
      "started": "Der Import läuft als Durchlauf des Import-Prozessschemas.",
      "starting": "Der Import-Durchlauf startet …",
      "unknown": "Der Durchlauf des Imports erscheint unter Quellverbindungen."
    },
    "segmentation": "Segmentierung",
    "segmentationHint": "Wie Dokumente in Segmente geteilt werden, im Format dmw-segmentation/1. Grenzmuster sind reguläre Ausdrücke in RE2-Syntax.",
    "segmentationInvalid": "Das ist kein JSON-Objekt. Prüfen Sie Klammern, Anführungszeichen und Kommas.",
    "submit": "Importieren",
    "submitRun": "Hochladen und Import ausführen",
    "templates": {
      "flat": "Ein Segment je Dokument",
      "fromInput": "Segmente vom Konverter",
      "headAndNumberedParts": "Kopf und nummerierte Teile"
    },
    "title": "Dokumente importieren",
    "tool": "Werkzeug: {{name}}",
    "workflow": "Import-Prozessschema",
    "workflowHint": "Läuft in einem Durchlauf: Dort sehen Sie durch, was er gefunden hat, und Kuratierende übernehmen das Ergebnis.",
    "workflowPinned": "Uploads in dieses Korpus laufen als Durchlauf des Prozessschemas, das sein erster Upload gewählt hat."
  },
  "index": {
    "intro": "Wählen Sie ein Dokument, um es zu lesen oder einen Durchlauf damit zu starten.",
    "noCorpusAction": "Dokumente importieren",
    "noCorpusAskSomeone": "Bitten Sie jemanden, der in diesem Projekt mitarbeitet, Dokumente zu importieren.",
    "noCorpusTitle": "Dieses Projekt hat noch kein Korpus",
    "openList": "Dokumentliste öffnen"
  },
  "list": {
    "empty": "Diese Korpusversion enthält keine Dokumente.",
    "loadMore": "Mehr laden",
    "noneFiltered": "Kein Dokument in diesem Korpus passt zu den Filtern.",
    "order": "Reihenfolge",
    "orders": {"creation": "Wie importiert", "key": "Nach Schlüssel"},
    "title": "Dokumente",
    "titleWithCount_one": "{{count}} Dokument",
    "titleWithCount_other": "{{count}} Dokumente"
  },
  "navigation": {
    "next": "Nächstes Dokument",
    "previous": "Vorheriges Dokument",
    "random": "Zufällig",
    "randomTitle": "Ein zufälliges Dokument öffnen"
  },
  "pages": {
    "openPdf": "PDF bei {{pages}} öffnen (neuer Tab)",
    "pdfOnly": "PDF S. {{pdf}}",
    "printed": "S. {{page}} (PDF {{pdf}})",
    "range": "{{first}} bis {{last}}"
  },
  "segment": {"title": "Segment {{segmentPath}}", "wholeDocument": "Ganzes Dokument"},
  "sidebar": {"noCorpus": "Dieses Projekt hat noch kein Korpus."}
}
